// extracted by mini-css-extract-plugin
module.exports = {"softlead__terms":"Softlead_softlead__terms__hlQ5A"};